// extracted by mini-css-extract-plugin
export default {"comingBackSoon":"ComingBackSoon_comingBackSoon__lvWu+","title":"ComingBackSoon_title__wuRnj","icon":"ComingBackSoon_icon__exIGd","description":"ComingBackSoon_description__iMgYN"};